/**
 * ONÉRO — tamanho sem marcar ao abrir a página do produto.
 *
 * O tamanho começa sem seleção visível e o botão de compra (e o da barra fixa) pede
 * "Please select a size." até a pessoa escolher. Menos troca por tamanho comprado sem querer.
 * Quem chega com ?variant= no link já escolheu, então não trava.
 * Carregado por snippets/variant-main-picker.liquid. O Find My Fit (assets/onero-fit-finder.js)
 * chama window.oneroSizeGate.pick(input) quando marca o tamanho recomendado.
 */
(() => {
  if (window.oneroSizeGate) return;

  const UNPICKED = 'onero-size-unpicked';
  const isSize = (input) => /size|tamanho/i.test(input?.dataset?.optionName || '');
  const sizeFieldset = (picker) =>
    picker && [...picker.querySelectorAll('fieldset')].find((f) => [...f.querySelectorAll('input')].some(isSize));
  const mainPicker = (root) => root.querySelector('variant-picker[ref="mainVariantPicker"]');

  const gated = new WeakMap(); // seção → true enquanto o tamanho não foi escolhido

  const applyGate = (section) => {
    const fs = sizeFieldset(mainPicker(section));
    if (fs) fs.classList.toggle(UNPICKED, gated.get(section) === true);
  };

  const pick = (input) => {
    const section = input.closest('.shopify-section');
    if (!section || !gated.get(section)) return;
    gated.set(section, false);
    applyGate(section);
    section.querySelector('.onero-size-alert')?.remove();
  };

  const init = () => {
    if (new URLSearchParams(location.search).has('variant')) return;
    document.querySelectorAll('variant-picker[ref="mainVariantPicker"]').forEach((picker) => {
      const section = picker.closest('.shopify-section');
      const fs = sizeFieldset(picker);
      if (!section || !fs || gated.has(section) || fs.querySelectorAll('input[type="radio"]').length < 2) return;
      gated.set(section, true);
      applyGate(section);
      // o tema redesenha o seletor quando troca a cor: põe o estado de volta
      new MutationObserver(() => applyGate(section)).observe(section, { childList: true, subtree: true });
    });
  };

  document.addEventListener('click', (e) => {
    const input = e.target instanceof HTMLInputElement ? e.target : null;
    if (input && input.type === 'radio' && isSize(input)) pick(input);
  });

  const alertSize = (section) => {
    const fs = sizeFieldset(mainPicker(section));
    if (!fs) return;
    if (!section.querySelector('.onero-size-alert')) {
      const msg = document.createElement('p');
      msg.className = 'onero-size-alert';
      msg.setAttribute('role', 'alert');
      msg.textContent = 'Please select a size.';
      fs.after(msg);
    }
    fs.classList.remove('onero-size-shake');
    void fs.offsetWidth;
    fs.classList.add('onero-size-shake');
    fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  // captura: roda antes do botão do tema (animação e envio)
  document.addEventListener(
    'click',
    (e) => {
      const btn = e.target instanceof Element ? e.target.closest('[ref="addToCartButton"]') : null;
      if (!btn) return;
      const sticky = btn.closest('sticky-add-to-cart');
      const section = sticky ? mainPicker(document)?.closest('.shopify-section') : btn.closest('.shopify-section');
      if (!section || !gated.get(section)) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      alertSize(section);
    },
    true
  );

  window.oneroSizeGate = { pick };

  const start = () => customElements.whenDefined('variant-picker').then(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
